import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Percent } from "lucide-react";
import { Card } from "@/components/ui/card";
import { TAX_REPORTS } from "@/lib/gstReports";

export default function Taxes() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div>
        <div className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Reports</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mt-1">Taxes</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Review GST, HSN, TDS and TCS figures recorded in your company&apos;s transactions.
        </p>
      </div>
      <Card className="p-4 text-sm text-amber-900 bg-amber-50 border-amber-200">
        These are internal summaries, not filed returns. GSTR-2B requires GST portal reconciliation,
        GSTR-7 requires GST TDS source records, and GSTR-3B values must be reviewed before filing.
      </Card>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {TAX_REPORTS.map(([key, label, description]) => (
          <Link key={key} to={`/gst/reports?report=${key}`} data-testid={`tax-report-${key}`}
            className="rounded-xl border bg-white p-4 hover:border-brand-500 hover:shadow-sm transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-600">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2 font-heading font-semibold"><Percent className="h-4 w-4 text-brand-600" />{label}</div>
              <ArrowRight className="h-4 w-4 text-muted-foreground shrink-0" />
            </div>
            <p className="text-xs text-muted-foreground mt-2">{description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}